import React from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCreative } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";


import placeholder from "../../../assets/image/loading.json";

const DesignSlider = (props) => {
  const { medias } = props;
  const imageLoaded = medias.map(() => {
    return false;
  });

  const [isImageLoaded, setIsImageLoaded] = React.useState(imageLoaded);
  const handelLoad = (index) => {
    const newStat = isImageLoaded.map((status, i) => {
      if (!isImageLoaded[index]) {
        return true;
      } else {
        return status;
      }
    });

    setIsImageLoaded(newStat);
  };

  return (
    <div className="col-12">
      <Swiper
        grabCursor={true}
        effect={"creative"}
        creativeEffect={{
          prev: {
            shadow: true,
            translate: [0, 0, -400],
          },
          next: {
            translate: ["100%", 0, 0],
          },
        }}
        modules={[EffectCreative, Pagination]}
        pagination={{
          dynamicBullets: true,
        }}
      >
        {medias.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="image-container ">
              <img
                className={isImageLoaded[index] ? "d-none" : "d-block"}
                src={placeholder.base64}
                alt="First slide"
              />
              <img
                className={isImageLoaded[index] ? "d-block" : "d-none"}
                src={item.mediaObj.mediaUrl}
                alt="First slide"
                onLoad={() => handelLoad(index)}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default DesignSlider;
